import { BehaviorSubject } from "rxjs";
import { delay, filter } from "rxjs/operators";
var EventsStore = /** @class */ (function () {
    function EventsStore() {
        this._storeUpdate$ = new BehaviorSubject(undefined);
    }
    EventsStore.prototype.setup = function (store) {
        var _this = this;
        store.subscribe(function () {
            _this._storeUpdate$.next(store);
        });
        // Initial update
        this._storeUpdate$.next(store);
    };
    Object.defineProperty(EventsStore.prototype, "storeUpdate$", {
        get: function () {
            return this._storeUpdate$.pipe(filter(function (store) {
                return !!store;
            }), delay(1));
        },
        enumerable: true,
        configurable: true
    });
    return EventsStore;
}());
export var eventsStore = new EventsStore();



//////////////////
// WEBPACK FOOTER
// ./src/events/eventsStore.ts
// module id = 453
// module chunks = 3